import PropTypes from 'prop-types';
import { useRef } from 'react'
import IframeResizer from 'iframe-resizer-react'

import { submitData } from '../collections/add/page/actions'

const AiIframe = ({url}) => {
  const iframeResizerRef = useRef(null);

  const messageHandler = async ({message = undefined}) => {
    switch (message?.key) {
      case "addGeneratedContentToCollection":
        let status = "failed";
        const body = message.body;
        const data = { title: body.title, body: body.htmlContent };
        const response = await submitData(data, false, '');
        if(response !== undefined && response?.id) {
          let builderResponse = await addToBuilder(response.id)
          builderResponse ? status = "completed" : undefined
        }
        iframeResizerRef.current.sendMessage({
          key: "addGeneratedContentToCollectionResult",
          body: { status: status },
        })
    }
    window.addEventListener('message', messageHandler)
  }

  return (
    <IframeResizer
      forwardRef={iframeResizerRef}
      src={url}
      onMessage={messageHandler}
      style={{ width: '1px', minWidth: '100%', minHeight: 'calc(85vh - 3.5rem)'}}
    />
  );
};

AiIframe.propTypes = {
  url: PropTypes.string,
};

export default AiIframe;

const addToBuilder = async (resourceId) => {
  return document.dispatchEvent(
    new CustomEvent('search-card-add', {
      detail: {
        collectionItemType: "CollectionItemPageResource",
        id: resourceId,
        classType: "PageResource",
        searchCardAdd: true
      }
    })
  );
}
